
<template>
  <div
    :class="hidedata?'city-s r-dr':'city-s'"
    v-loading="loadingRight"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="l-t hh3">
      <h3 v-html="heightName"></h3>
      <span>途径城市数据</span>
    </div>
    <h5>加油站停靠（日均）</h5>
    <div class="ci1">
      <div class="ci1-l">
        <p>
          {{objData.gasStation}}
          <span class="l">次</span>
        </p>
      </div>
    </div>
    <div style="width:400px">
      <div class="pieChart" id="pieChart"></div>
    </div>
    <div class="ci1">
      <div class="ci1-l ci1-111">
        <div v-for="i in chartData[0].newData" :key="i.id">
          <div v-if="i.name=='中石化'"></div>
          <div v-if="i.name=='中石油'" class="cd1"></div>
          <div v-if="i.name=='其他'" class="cd2"></div>
          {{i.name}}
          <span>{{i.value}}次</span>
        </div>
      </div>
    </div>
    <h5>物流园停靠（日均）</h5>
    <div class="ci1">
      <div class="ci1-l">
        <p>
          {{objData.logisticsPark}}
          <span class="l">次</span>
        </p>
      </div>
    </div>
    <h5>道路加油站密度</h5>
    <div class="ci1">
      <div class="ci1-l">
        <p>
          {{objData.density}}
          <span class="l">座 / 百公里</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  props: ['objData'],
  data() {
    return {
      objData: {}
    }
  },
  props: {
    loadingRight: Boolean,
    heightName: String,
    hidedata: Boolean,
    chartData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    chartData(newV, oldV) {
      this.objData = this.chartData[0]
      this.initChart()
    }
  },
  created() {},
  mounted() {
    this.objData = this.chartData[0]
    this.initChart()
  },
  methods: {
    initChart() {
      let that = this
      let city = echarts.init(document.getElementById('pieChart'))
      let option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        color: ['#268FFF', '#03DD94', '#ffffff'],
        series: [
          {
            name: '数据来源',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: '10'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: that.chartData[0].newData
          }
        ]
      }
      city.setOption(option)
    }
  }
}
</script>
<style>
.pieChart {
  width: 180px;
  margin-top: 0px;
  margin-left: 55px;
  height: 180px;
}
.city-s h5 {
  font-size: 12px;
  margin: 0;
  padding: 20px 0;
  opacity: 0.5;
  margin: 15px;
  border-top: 1px solid #393a55;
  margin-bottom: 0;
  margin-top: 15px;
  font-weight: normal;
}
#pieChart > div:last-child {
  left: 0 !important;
}
.ci1 {
  font-size: 12px;
  margin: 0 15px;
  /* display: flex;
  align-items: center; */
}
.ci1 p {
  font-size: 28px;
  margin: 20px 0;
  margin-top: 0;
}
.ci1-l > div {
  margin-bottom: 9px;
  opacity: 0.9;
}
.ci1-l div span {
  margin-left: 5px;
}
.ci1-l p span.l {
  font-size: 10px;
}
.ci1-l div div {
  width: 8px;
  height: 8px;
  margin-right: 10px;
  background: #03dd94;
  display: inline-block;
}
.ci1-l {
  display: inline-block;
}
.ci1-l div div.cd1 {
  background: #268fff;
}
.ci1-l div div.cd2 {
  background: #ffffff;
}
.ci1-111 {
  margin-left: 40px;
  margin-top: 0px;
}
</style>